// API base URL — always use same origin as the frontend.
// This ensures API calls work on any deployment domain (lusolove.com, preview, etc.)
// since both preview and production route /api/* to the backend via their respective proxies.
const API_URL = '';

export default API_URL;
